import { CACHE_FETCH_LIFESTYLE_TYPES_QUERY } from '../../queries/fetchCacheLifestyleTypes.query';
import {
  FetchLifestyleTypesQueryResponse,
  FETCH_LIFESTYLE_TYPES_QUERY
} from '../../queries/fetchLifestyleTypes.query';

import { useCacheInfiniteIndexQuery } from '../../../common/reactQuery/hooks/useCacheInfiniteIndexQuery';

import {
  INITIAL_LIFESTYLE_TYPES_FILTERS,
  INITIAL_LIFESTYLE_TYPES_LIMIT,
  INITIAL_LIFESTYLE_TYPES_SORT
} from '../../lifestylesConstants';

import {
  FetchFinLifestyleCategoriesFilters,
  FetchLifestyleCategoriesCacheKey,
  FetchLifestyleCategoriesLimit,
  FetchLifestyleCategoriesSort
} from '../../lifestylesTypes';

import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const scope = 'categories';

const options = {
  staleTime: 1000 * 60 * 60
};

interface LifestyleTypesDefaultOptions {
  cacheKey: FetchLifestyleCategoriesCacheKey;
  initialFilters?: FetchFinLifestyleCategoriesFilters;
  initialSort?: FetchLifestyleCategoriesSort;
  initialLimit?: FetchLifestyleCategoriesLimit;
  options?: {
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
}

function useFinLifestyleTypes({
  cacheKey,
  initialFilters = INITIAL_LIFESTYLE_TYPES_FILTERS,
  initialSort = INITIAL_LIFESTYLE_TYPES_SORT,
  initialLimit = INITIAL_LIFESTYLE_TYPES_LIMIT
}: LifestyleTypesDefaultOptions) {
  const {
    items,
    itemsError,
    isFetched,
    isPlaceholderData,
    isFetchingNextPage,
    currentFilters,
    hasNextPage,
    loadMoreItems,
    filterItems,
    changeItemsFilters
  } = useCacheInfiniteIndexQuery<FetchLifestyleTypesQueryResponse>({
    action: CategoriesPermissions.READ_LIFESTYLE_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    cacheQuery: CACHE_FETCH_LIFESTYLE_TYPES_QUERY,
    defaultApi: 'cache_api',
    query: FETCH_LIFESTYLE_TYPES_QUERY,
    initialFilters,
    initialSort,
    initialLimit,
    scope,
    options
  });

  return {
    lifestyleTypes: items,
    lifestyleTypesErrorMessage: itemsError,
    lifestyleTypesFetched: isFetched,
    lifestyleTypesIsPlaceholderData: isPlaceholderData,
    lifestyleTypesFetchingNextPage: isFetchingNextPage,
    lifestyleTypesFilters: currentFilters,
    hasNextLifestyleTypesPage: hasNextPage,
    loadMoreLifestyleTypes: loadMoreItems,
    lifestyleTypesFilterSearchValue: currentFilters?.name?.ilike,
    filterLifestyleTypes: filterItems,
    changeLifestyleTypesFilters: changeItemsFilters
  };
}

export default useFinLifestyleTypes;
